// extracted by mini-css-extract-plugin
export default {"root":"ConfimModalCloseButton_root__9s2o7"};